import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  isMenuOpen: boolean = false;
  constructor(
    private router: Router,
  ) {

  }
  navigate(param: any) {
    if (param === 'about-us') {
      this.router.navigate(['/About-Us'])
    }
    else if (param === 'approach') {
      this.router.navigate(['/Approach'])
    }
    else if (param === 'collaborate') {
      this.router.navigate(['/Collaborate'])
    }
  }
  scrollToSection(sectionId: string) {
    if (this.router.url !== '/') {
      // Navigate to home first
      this.router.navigate(['/']).then(() => {
        setTimeout(() => {
          this.performScroll(sectionId);
        }, 300); // wait for DOM to load
      });
    } else {
      this.performScroll(sectionId);
    }
  }

  private performScroll(sectionId: string) {
    const element = document.getElementById(sectionId);

    if (element) {
      const yOffset = -100; // adjust for fixed header
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
  toggleMenu() {
  this.isMenuOpen = !this.isMenuOpen;
}

closeMenu() {
  this.isMenuOpen = false;
}

}
